const hasPermission = (permission) => {
	try {
		const permissions = JSON.parse(localStorage.getItem("permissions") || "{}");
		return !!permissions[permission];
	} catch {
		return false;
	}
};

export default hasPermission;
